module.exports = __webpack_public_path__ + "assets/media/evening.06634554.mp3";